import { Dispatch, SetStateAction } from 'react';
import { FormInstance } from 'antd';

import { findTableRow, removeItemFromArrayWithState } from 'utils';

export const handleUndoRow = <T extends Record<string, unknown>>({
  form,
  setEditingKey,
  setIsFormValid,
}: {
  form: FormInstance<T>;
  setIsFormValid: (status: boolean) => void;
  setEditingKey: (editKey: undefined) => void;
}) => () => {
  setIsFormValid(false);
  setEditingKey(undefined);
  form.resetFields();
};

export const handleDeleteAddedRow = <T extends Record<string, unknown>>({
  form,
  recordKey,
  setEditingKey,
  setIsFormValid,
  setEditableTableData,
}: {
  form: FormInstance<T>;
  recordKey: number;
  setEditingKey: (editKey: undefined) => void;
  setIsFormValid: (status: boolean) => void;
  setEditableTableData: Dispatch<SetStateAction<T[] | undefined>>;
}) => () => {
  if (recordKey === 0) {
    handleUndoRow({ form, setIsFormValid, setEditingKey })();
    removeItemFromArrayWithState({ setState: setEditableTableData });
  }
};

export const handleSaveRow = <T extends Record<string, unknown>>({
  form,
  recordKey,
  editableTableData = [],
  setEditingKey,
  onPostTableData,
  onPatchTableData,
  setEditableTableData,
}: {
  form: FormInstance<T>;
  recordKey: number;
  editableTableData?: T[];
  setEditingKey: (key: undefined) => void;
  onPostTableData?: (data: T) => void;
  onPatchTableData?: (data: T) => void;
  setEditableTableData: Dispatch<SetStateAction<T[] | undefined>>;
}) => async () => {
  const row = await form.validateFields();
  const rowData = findTableRow(recordKey, editableTableData);

  form.resetFields();
  setEditingKey(undefined);
  removeItemFromArrayWithState({ setState: setEditableTableData });

  if (onPostTableData && recordKey === 0) {
    return onPostTableData(row);
  }

  return onPatchTableData?.({ id: rowData.id, ...row });
};
